module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content py-4"
  }, [_c('div', {
    staticClass: "row px-3"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title col-12"
  }, [_vm._v("Datos del usuario")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Nombre y apellidos: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.name))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("DNI: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.document))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Direccion: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.direction))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Teléfono: ")]), _vm._v(_vm._s(_vm.detalleReclamo.phone))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("E-mail: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.email))]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Fecha de reclamo: ")]), _vm._v(" " + _vm._s(_vm.detalleReclamo.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 pt-4"
  }, [_c('h2', {
    staticClass: "form-title-principal form-title col-12"
  }, [_vm._v("Cuéntanos que pasó...")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Tipo de reclamo:  ")]), _vm._v("\n        " + _vm._s(_vm.detalleReclamo.type) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', [_vm._v("Servicio o producto del reclamo:  ")]), _vm._v("\n         " + _vm._s(_vm.detalleReclamo.store_id === 1 ? 'SENDI' : 'ENVIOS USA') + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("¿Cuál fué el problema?")]), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("\n           " + _vm._s(_vm.detalleReclamo.problem) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "ml-0 col-12"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("¿Qué solución esperas?")]), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("\n           " + _vm._s(_vm.detalleReclamo.solution) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5972b3db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ReclamoDetails.vue
// module id = 1881
// module chunks = 1